import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { light, dark } from './palette';

const getTheme = () => {
  // const {themeMode} = get theme mode from state light or dark
  const themeMode = 'light'; // the only available right now

  return responsiveFontSizes(
    createMuiTheme({
      custom: {
        colors: {
          emerald: '#50c878',
          wetAsphalt: '#1a252f',
          oceanBlue: '#006994',
          seaGreen: '#2e8b57',
          pumpkin: '#ff7518',
        },
      },
      palette: 'light' === themeMode ? light : dark,
      layout: {
        topBarHeight: 60,
        contentWidth: 1236,
        drawerWidth: 240,
      },
      typography: {
        fontFamily: 'Roboto',
      },
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
      overrides: {
        MuiTypography: {
          subtitle2: {
            fontSize: [ 12, '!important' ],
          },
        },
        MuiButton: {
          root: {
            '&:focus': {
              outline: 'none',
            },
          },
        },
      },
    }),
  );
};

export default getTheme;
